export const panFormatter = input => {
  let formatted = '';
  let idx = 0;
  let character = '';
  const normalized = input.replace(/\s/g, '');
  while (idx < normalized.length) {
    character = normalized.substring(idx, idx + 1);
    if (idx !== 0 && idx % 4 === 0) {
      formatted = formatted.concat(' ');
    }
    formatted = formatted.concat(character);
    idx += 1;
  }
  return formatted;
};

export const expireDateFormatter = date => {
  let formatted = '';
  let idx = 0;
  let character = '';
  const normalized = date.replace('/', '');
  while (idx < normalized.length) {
    character = normalized.substring(idx, idx + 1);
    if (idx !== 0 && idx % 2 === 0) {
      formatted = formatted.concat('/');
    }
    formatted = formatted.concat(character);
    idx += 1;
  }
  return formatted;
};
